import styled from 'styled-components';
import Icon from '../Icon';
export var StyledIconStatus = styled(Icon).withConfig({
  displayName: "IconStatusstyles__StyledIconStatus",
  componentId: "sc-hzry6a-0"
})([""]);